import type { AdminPreset, FieldError, PresetFields } from '../../api/imagePresets';

/** 422 errors → 필드 이름별 메시지. loc 가 빈 것(프리셋 전체 규칙)은 '' 키로 모은다. */
export const fieldErrors = (errors: FieldError[] | undefined): Record<string, string[]> => {
  const byField: Record<string, string[]> = {};
  for (const err of errors ?? []) {
    const key = err.loc[0] ?? '';
    (byField[key] ??= []).push(err.msg);
  }
  return byField;
};

export const formatBytes = (n: number): string =>
  n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.ceil(n / 1024)} KB`;

const kst = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});
export const formatKst = (iso: string): string => kst.format(new Date(iso));

/** 화면이 어느 환경 DB 를 고치는지. 서버가 index.html 에 넣어 준다. */
export const serverEnv = (): string => (typeof window !== 'undefined' && window.__APP_CONFIG__?.env) || 'dev';

/** 저장본 → 편집할 필드(버전·시각·작성자 제외). */
export const toFields = (p: AdminPreset): PresetFields => ({
  id: p.id,
  name: p.name,
  category: p.category,
  description: p.description,
  prompt: p.prompt,
  negative_prompt: p.negative_prompt,
  variables: p.variables,
  allow_text_in_image: p.allow_text_in_image,
  aspect: p.aspect,
  reference_images: p.reference_images,
  provider: p.provider,
  model: p.model,
  quality: p.quality,
  enabled: p.enabled,
  order: p.order,
});

/** 투명한 부분이 보이게 이미지 뒤에 까는 체크무늬. */
export const CHECKERBOARD = 'bg-[repeating-conic-gradient(#f1f5f9_0%_25%,#fff_0%_50%)] bg-[length:16px_16px]';
